import {SODeleteProject} from '../../core/project/so-delete-project';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteProject extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteProject;
}